import { NgModule, CUSTOM_ELEMENTS_SCHEMA, Injector } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgbDatepicker, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ToastModule } from 'primeng/toast';
import { ColorPickerModule } from 'primeng/colorpicker';
import { ConfirmationService, MessageService } from 'primeng/api';
import { SliderModule } from 'primeng/slider';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { DefaultInterceptor } from 'src/app/default.interceptor';
import { AuthStore } from '../auth/state/auth.store';
import { AuthQuery } from '../auth/state/auth.query';
import { AuthService } from '../auth/state/auth.service';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { LOCALE_ID } from '@angular/core';
import { DatepickerI18nComponent } from './components/datepicker-i18n/datepicker-i18n.component';
import { TimepickerComponent } from './components/timepicker/timepicker.component';
import { numselectComponent } from './components/numselect/numselect.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { CrudService } from './services/crud.service';
import { SnotifyModule, SnotifyService, ToastDefaults } from 'ng-snotify';
import { RolePickerComponent } from './components/role-picker/role-picker.component';
import { SelectButtonModule } from 'primeng/selectbutton';
import { PickerComponent } from './components/picker/picker.component';
import { CommonModule } from '@angular/common';
import { EnumToArray } from './pipes/enumToArray.pipe';
import { YearselectComponent } from './components/yearselect/yearselect.component';
import { FormfieldComponent } from './components/formfield/formfield.component';
import { UserpickerComponent } from './components/userpicker/userpicker.component';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { DatepickerDefaultComponent } from './components/datepicker-default/datepicker-default.component';
import { RangePickerComponent } from './components/range-picker/range-picker.component';
import { SinglepickerComponent } from './components/singlepicker/singlepicker.component';
import { TilepickerComponent } from './components/tilepicker/tilepicker.component';
import { SingletilepickerComponent } from './components/singletilepicker/singletilepicker.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CheckboxModule } from 'primeng/checkbox';
import { FileUploadModule } from 'primeng/fileupload';
import { FilepickerComponent } from './components/filepicker/filepicker.component';
import { TileinputComponent } from './components/tileinput/tileinput.component';
import { ChipsModule } from 'primeng/chips';
import { ReplacePipe } from './pipes/replacePipe';
import { JoinPipe } from './pipes/joinPipe';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputSwitchModule } from 'primeng/inputswitch';
import { DocumentopickerComponent } from './components/documentopicker/documentopicker.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ProgressBarModule } from 'primeng/progressbar';
import { MenuModule } from 'primeng/menu';
import { ChipModule } from 'primeng/chip';
import { TooltipModule } from 'primeng/tooltip';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DocumentoComponent } from './components/documento/documento.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ListboxModule } from 'primeng/listbox';
import { MatListModule } from '@angular/material/list';
import { MatBadgeModule } from '@angular/material/badge';
import { PostItComponent } from './components/postit/postit.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SidebarModule } from 'primeng/sidebar';
import { FilepickerMultipleComponent } from "./components/filepickermultiple/filepickermultiple.component";
import { SortablejsModule } from "ngx-sortablejs";

const maskConfig: Partial<IConfig> = {
  validation: false,
};

// AoT requires an exported function for factories
// tslint:disable-next-line: typedef
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    DatepickerI18nComponent,
    TimepickerComponent,
    numselectComponent,
    RolePickerComponent,
    PickerComponent,
    EnumToArray,
    ReplacePipe,
    JoinPipe,
    YearselectComponent,
    FormfieldComponent,
    UserpickerComponent,
    DatepickerDefaultComponent,
    RangePickerComponent,
    SinglepickerComponent,
    TilepickerComponent,
    SingletilepickerComponent,
    FilepickerComponent,
    FilepickerMultipleComponent,
    DocumentopickerComponent,
    TileinputComponent,
    DocumentoComponent,
    HeaderComponent,
    FooterComponent,
    PostItComponent,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    ButtonModule,
    SnotifyModule,
    DialogModule,
    ConfirmPopupModule,
    ToastModule,
    ColorPickerModule,
    SelectButtonModule,
    OverlayPanelModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTabsModule,
    MatSlideToggleModule,
    MatInputModule,
    OverlayModule,
    NgbModule,
    NgbDatepicker,
    HttpClientModule,
    TranslateModule,
    DatepickerI18nComponent,
    SidebarModule,
    TimepickerComponent,
    numselectComponent,
    RolePickerComponent,
    HeaderComponent,
    FooterComponent,
    PickerComponent,
    MatChipsModule,
    MatAutocompleteModule,
    MatIconModule,
    DropDownsModule,
    EnumToArray,
    ReplacePipe,
    JoinPipe,
    YearselectComponent,
    DocumentopickerComponent,
    FormfieldComponent,
    UserpickerComponent,
    NgxMaskModule,
    FontAwesomeModule,
    AngularEditorModule,
    NgxSkeletonLoaderModule,
    ConfirmDialogModule,
    DatepickerDefaultComponent,
    SliderModule,
    RangePickerComponent,
    SinglepickerComponent,
    TilepickerComponent,
    SingletilepickerComponent,
    AutoCompleteModule,
    CheckboxModule,
    FileUploadModule,
    FilepickerComponent,
    FilepickerMultipleComponent,
    TileinputComponent,
    ChipsModule,
    MultiSelectModule,
    InputSwitchModule,
    ProgressSpinnerModule,
    ProgressBarModule,
    MenuModule,
    ChipModule,
    TooltipModule,
    MatTooltipModule,
    DocumentoComponent,
    ListboxModule,
    MatListModule,
    MatBadgeModule,
    PostItComponent,
    DragDropModule
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgxSkeletonLoaderModule,
    ReactiveFormsModule,
    OverlayPanelModule,
    DialogModule,
    ConfirmDialogModule,
    CheckboxModule,
    NgbModule,
    SnotifyModule,
    SidebarModule,
    FileUploadModule,
    SliderModule,
    MatBadgeModule,
    MatIconModule,
    ChipsModule,
    InputSwitchModule,
    AngularEditorModule,
    AutoCompleteModule,
    FontAwesomeModule,
    ChipModule,
    TooltipModule,
    MultiSelectModule,
    ProgressSpinnerModule,
    MenuModule,
    ProgressBarModule,
    MatTooltipModule,
    ListboxModule,
    MatListModule,
    DragDropModule,
    NgxMaskModule.forRoot(maskConfig),
    SortablejsModule.forRoot({ animation: 150 }),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      defaultLanguage: 'it-IT',
      isolate: false
    }),
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: DefaultInterceptor,
    multi: true,
    deps: [Injector, AuthStore, AuthQuery, AuthService]
  }, MatDatepickerModule, { provide: MAT_DATE_LOCALE, useValue: 'it-IT' }, { provide: 'SnotifyToastConfig', useValue: ToastDefaults },
    SnotifyService, ConfirmationService, MessageService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule { }
